import type { QueryMetrics200ItemTags } from './queryMetrics200ItemTags';

export type QueryMetrics200Item = {
  id?: number;
  name: string;
  tags?: QueryMetrics200ItemTags;
  timestamp: string;
  type: string;
  userId: string;
  value: number;
};
